import AdminLayout, { BreadCum } from "../admin";
export { BreadCum };
export default AdminLayout;
